import React, { useEffect, useState } from "react";
import { Button, ButtonToolbar, Loader, Container, Modal } from "rsuite";
import { ProductServices } from "../../../core/services/ProductServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./Products.css";
import { useTranslation } from "react-i18next";
import { get } from "lodash/fp";
import CompanyProducts from "./CompanyProducts";
import { Permission } from "./ProductDataTypes";

const ViewCompanyProductsModal = ({
  companyId,
  openModal,
  setOpenModal,
  onDeleteProduct,
  ...props
}: {
  companyId: number;
  openModal: boolean;
  setOpenModal: Function;
  onDeleteProduct?: Function;
}) => {
  const { t } = useTranslation();

  const [loader, setLoader] = useState(false);
  const [productInfo, setProductInfo] = useState<any>({});
  const [productTypeFieldDetails, setProductTypeFieldDetails] = useState<any>(
    []
  );

  const permissionBulkObj: Permission = {
    delete: UtilityServices.hasPermission("delete-company-product"),
    back_to_list: false,
  };

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={openModal}
        backdrop={false}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="lg"
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("VIEW")} {t("PRODUCTS")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="products view-products">
            <Container className="container">
              <CompanyProducts
                forCompany={companyId}
                onDelete={onDeleteProduct}
                withAdvanceFilter={false}
                withHeader={false}
                bulkActionPermission={permissionBulkObj}
              />
              <ButtonToolbar className="btn-center">
                <Button
                  onClick={(e: any) => setOpenModal("")}
                  color="red"
                  appearance="primary"
                >
                  {t("CLOSE")}
                </Button>
              </ButtonToolbar>
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewCompanyProductsModal;
